import styled from 'styled-components';

import DOWN from '../../../assets/imgs/icon/arrow_down.svg';
import UP from '../../../assets/imgs/icon/arrow_up.svg';
import CART from '../../../assets/imgs/icon/cart.svg';
import { Flex } from '../../../GlobalComponents/Flex';
import { Icon } from '../../../GlobalComponents/Icon';
import { useAppSelector } from '../../../reduxstore/hooks';

export type TogglerProps = {
	isActive: boolean;
	onClick: () => void;
};

export const Toggler: React.FC<TogglerProps> = ({ isActive, onClick }) => {
	const total = useAppSelector(
		state => state.checkoutReducer.cartTotalPlusTax
	);

	return (
		<ToggleCart
			$flexDirection="column"
			$margin="0 0 0 -16px"
			$padding="0 16px 16px 16px"
			$backgroundColor="#F5F2F2"
		>
			<Flex
				$flexDirection="row"
				$placeContent="center space-between"
				$alignItems="center"
			>
				<Text>Checkout</Text>
				<Text>${total}</Text>
			</Flex>
			<Flex $flexDirection="row" $placeContent="center flex-end">
				<Toggle onClick={onClick}>
					<Icon $url={CART} alt={'Cart'}></Icon>
					{isActive ? 'Hide' : 'Show'} order summary
					<Icon
						$url={isActive ? UP : DOWN}
						alt={'arrow'}
						$width={24}
						$height={24}
					></Icon>
				</Toggle>
			</Flex>
		</ToggleCart>
	);
};

const ToggleCart = styled(Flex)`
	font-size: 70%;
	border-bottom: 1px solid #000;
	position: fixed;
	top: 59px;
	height: 72px;
	z-index: 1000;
	@media (min-width: ${({ theme }) => theme.gridBreakpoints?.xxs}) {
		font-size: 75%;
	}

	@media (min-width: ${({ theme }) => theme.gridBreakpoints?.xms}) {
		font-size: 100%;
	}
`;

const Text = styled.div`
	color: #222;
	font-size: 24px;
	font-weight: 700;
`;

const Toggle = styled.div`
	flex-direction: row;
	display: flex;
	place-content: center flex-end;
	column-gap: 5px;
	font-weight: 500;
	font-size: 16px;
	align-items: center;
	color: #222;
	&:hover {
		cursor: pointer;
	}
`;
